import { nextTick } from '@patrianna/shared-utils'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { getQuickPurchaseSupportedTypeSelector } from '@patrianna-payments/shared-store/payments/store/selectors'
import { usePathname, useRouter } from 'next/navigation'

import Button from 'components/Button'
import Amount from 'containers/Layouts/Layout/Header/components/Amount'
import GoldCurrency from 'containers/Layouts/Layout/Header/components/LoggedIn/GoldCurrency'
import SweepstakeCurrency from 'containers/Layouts/Layout/Header/components/LoggedIn/SweepstakeCurrency'
import content from 'prismic-translates/common.json'
import { trackSPPlacementInteracted } from 'src/analyticActions/common/trackPaymentSnowplow'
import CashSwitcher from 'src/containers/CashSwitcher'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { getIsAcceptedRulesForScUser, sweepstakeEnabledSelector } from 'store/modules/appConfig/selectors'
import { setActiveCurrency } from 'store/modules/currencies/actions'
import { getActiveCurrencyIdSelector, getCurrencyInitializedSelector } from 'store/modules/currencies/selectors'
import { openShopHandler } from 'store/modules/shop/actions'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

type Props = {
  collapseCurrency?: boolean
}

function LoggedIn(props: Props) {
  const router = useRouter()
  const isAcceptedRulesForScUser = useAppSelector(getIsAcceptedRulesForScUser)
  const currencyInitialized = useAppSelector(getCurrencyInitializedSelector)
  const activeCurrency = useAppSelector(getActiveCurrencyIdSelector)
  const isScEnabled = useAppSelector(sweepstakeEnabledSelector)
  const dispatch = useAppDispatch()
  const pathname = usePathname()
  const { isQuickPurchase } = useAppSelector((state) => getQuickPurchaseSupportedTypeSelector(state, pathname))

  const handleShopClick = () =>
    nextTick().then(() => {
      dispatch(openShopHandler(false, router.push, null, true))
      trackSPPlacementInteracted({
        paymentFlow: isQuickPurchase ? 'quick_purchase' : 'coin_store',
        placementName: 'cta_button',
        interactionName: isQuickPurchase ? t('quick_purchase') : t('get_coins'),
        placementTrigger: 'click_menu_button',
      })
    })

  if (!currencyInitialized) {
    return null
  }

  return (
    <div className={classes.root} data-test='header-balance'>
      {activeCurrency && props.collapseCurrency && <Amount activeCurrency={activeCurrency} />}

      <Button
        dataTestId='common-header-buy-button'
        onClick={handleShopClick}
        variant='contained'
        size='small'
        className={classes.shopLink}
        disabled={!isAcceptedRulesForScUser}
      >
        {isQuickPurchase ? t('quick_purchase') : t('get_coins')}
      </Button>

      {isScEnabled ? (
        <CashSwitcher
          dataAttribute='header'
          mode='headerMode'
          activeCurrency={activeCurrency}
          handleChange={({ activeCurrencyId }) => dispatch(setActiveCurrency({ activeCurrencyId }))}
          GoldCurrencyComponent={GoldCurrency}
          SweepstakeCurrencyComponent={SweepstakeCurrency}
          collapseCurrency={props.collapseCurrency}
          reversed
        />
      ) : (
        !props.collapseCurrency && (
          <div className={classes.currency}>
            <GoldCurrency />
          </div>
        )
      )}
    </div>
  )
}

export default LoggedIn
